// GET_COIN_PACKAGE
export const GET_COIN_PACKAGE = "GET_COIN_PACKAGE";

// CREATE_COIN_PACKAGE
export const CREATE_COIN_PACKAGE = "CREATE_COIN_PACKAGE";

// UPDATE_COIN_PACKAGE
export const UPDATE_COIN_PACKAGE = "UPDATE_COIN_PACKAGE";

// DELETE_COIN_PACKAGE
export const DELETE_COIN_PACKAGE = "DELETE_COIN_PACKAGE";
